console.log("Privezi Newsletter JS Loaded");
// var timeout = 0;
var firstVisit = false;
var popSelect = document.querySelector('.bcontact_select');
var popupTriggerBtn;
setTimeout(() => {
  popupTriggerBtn = document.querySelector('.bcontact-trigger-button');

// var popupTriggerBtn = document.querySelector('.bcontact-trigger-button');
if (!localStorage.getItem('hasVisited')) {
  console.log('First Time loading');
  localStorage.setItem('hasVisited', 'true');
  firstVisit = true;
  firstVisitExc();
} else {
  console.log('Loaded before');
  // timeout = 16000;
  firstVisit = false;
  popupTriggerBtn.addEventListener('click', function () {
    if(popSelect){
      popSelect.remove();
    }
    setTimeout(() => {
      priveziPopup();
    }, 500);
  });
}
}, 1000);

function firstVisitExc() {
  setTimeout(() => {
    priveziPopup();
  }, 16000);
}
function priveziPopup() {
    let purposeObj = null;
    let languageListObj = [];

    //Document Step 2: Use the API key provided from the document
	var apiKey = 'D9TNKM3EROXF0UMT4VPE7WV67CH351OI1DP2LICBOH79PLIT7ZR1JIDSSX7S9GSRJO7KA8AQMCAJSA2SNTTQB8BCHGK0S3LIZHLNRLAAGNAXCWR1BV9WMCS10RMM8UQWBKHTIF78SO2FMU6XH5RID20WT21VH3F2DJCOTKUGXTSMFTK2DTMKWMT5WBDHR5I1O8ER5FY15ZM6V21JXX0QO5SAF1JO87Z46AZP57HFB8V388B99S3Y52T5SXHQXHLU';

	//Document Step 3: Calling the Get Consent Purposes API
    async function handleToGetPurposeApi() {
      try {
        const response = await fetch(
          `https://api.voltasworld.com/edge-service/consent-service/getPurposesByConsentPoint/offers-Voltas.com?apiKey=${apiKey}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });


        const json = await response.json();
        purposeObj = json;
        languageListObj = json?.languagesList;
        const uniqueLanguageKeys = {};


        // Collect all language keys from the API response
        purposeObj.purposes.forEach((item) => {
          const labels = item[Object.keys(item)[0]].labels;
          Object.keys(labels).forEach((key) => {
            const normalizedKey = key === 'default' ? 'English' : key;
            if (!uniqueLanguageKeys.hasOwnProperty(normalizedKey)) {
              uniqueLanguageKeys[normalizedKey] = labels[key];
            }
          });
        });
        console.log("uniqueLanguageKeys", uniqueLanguageKeys)

		//Adding languages to the Drop Down
        renderLang(uniqueLanguageKeys);

		//Adding checkboxes to the page
        renderCheckboxes('English');
      } 
	  catch (error) {
        console.error('API fetch error:', error);
        renderCheckboxes('English');
      }
  }

    handleToGetPurposeApi();

    var checkboaxwrapper = document.getElementById("purposeCheckConsent");


    function getdataAsPerLang(value, lang) {
      console.log("getdataAsPerLang", {value, lang})
      const labels = Object.values(value)[0].labels;
      console.log("getdataAsPerLang 1", labels)

      return labels[lang] || labels.default || 'Default Label';

    }

    function renderLang(languageArray) {
      const keysArray = Object.keys(languageArray).map((key) =>
        key === 'default' ? 'English' : key
      );
      console.log("keysArray",{languageArray, keysArray})
      if (keysArray.length) {
        const languageContainer = document.getElementById('language');
        languageContainer.innerHTML = `
                  <div>Change Language</div>
                  <select id="languageSelectPop" style="width: auto; display: inline-block; margin-top: 10px;">
                    ${keysArray
            .map(
              (lang, index) => `<option value="${languageListObj?.find((ele)=> ele.name == lang)?.id || 0}" ${lang === 'English' ? 'selected' : ''}>${lang}</option>`
            )
            .join('')}
                  </select>
                `;

        // Add change event listener to dropdown
        document.getElementById('languageSelectPop').addEventListener('change', function (e) {
          const selectedLang = e.target.value;
          const selectEl = e.target;
          const selectedValue = selectEl.value;
          const selectedText = selectEl.options[selectEl.selectedIndex].textContent;
          console.log('languages selectedText:', selectedText);
          renderCheckboxes(selectedText);
        });
      } else {
        console.error('No languages available:', keysArray);
      }

    }

    

    function renderCheckboxes(lang) {
         if (!lang) {
          console.error(`Element with ID ${lang} not found`);
          return;
        }
      // Clear previously rendered checkboxes
      checkboaxwrapper.innerHTML = '';
      //  var intNews = setInterval(() => {
        // if(checkboaxwrapper.children.length === 0 && checkboaxwrapper.textContent.trim() === ""){
          // console.error('No checkboxes rendered');
          if (purposeObj && purposeObj.purposes) {
            purposeObj.purposes.forEach((purpose) => {
              const purposeKey = Object.keys(purpose)[0].replace(/\s+/g, '');
              console.log("purposeKey",purposeKey)
              const isRequired = Object.values(purpose)[0].is_required;
              const labelHTML = getdataAsPerLang(purpose, lang); // Get label for selected language


              checkboaxwrapper.innerHTML += `
            <div class="checkbox">
              <input type="checkbox" class="priv_check" id="${purposeKey}" name="${purposeKey}" ${isRequired ? 'required' : ''}>
              <span class="danger">${isRequired ? '* ' : ' '}</span>
              <label for="${purposeKey}">${labelHTML}</label>
            </div>
            `;
            });
          }
        // }
          
          
        // else {
        //   console.log('checkboxes rendered');
        //   clearInterval(intNews);
        // }
      // }, 1000);

    }


    const form = document.getElementById('bcontact-form-473137');
    
    
    function getvaluesfromChckbox() {
      let setcheckVal = {};
      if (purposeObj && purposeObj.purposes) {
        purposeObj.purposes.forEach((purpose) => {
          // console.log('purposeObj',purposeObj);
          // console.log('purposeObj.purposes',purposeObj.purposes);
          const purposeKey = Object.keys(purpose)[0].replace(/\s+/g, '');
          setcheckVal = {
            ...setcheckVal,
            [purposeKey]: form.querySelector(`#${purposeKey}`).checked,
          };
        });
      }
      console.log('setcheckVal',setcheckVal);
      return setcheckVal;
    }
    var popSelect = document.querySelector('.bcontact_select');
    // popSelect.remove();

    var checks= document.querySelectorAll('.priv_check');
    checks.forEach((check)=>{
      console.log('checksssss');
      console.log(check);
      check.addEventListener('click',()=>{
        if(check.checked){
          console.log('check',check);
          console.log('check value',check.checked);
        }
      
      })
    }
    )
    form.addEventListener('submit', async function (e) {

      e.preventDefault();
      // const langelement = document.querySelector('.langactive');
      // const textLangContent = langelement ? langelement.textContent : 'English';
      
      const langSelect = document.getElementById('languageSelectPop');
      const selectedOption = langSelect.options[langSelect.selectedIndex];
      const textLangContent = selectedOption.textContent; 
      const textLangId = Number(selectedOption.value);  
      const purpose = getvaluesfromChckbox();
      
      const payload = new FormData(form); 
      console.log("payload", payload);
      const formDataSer = Object.fromEntries(payload);
      console.log("formDataSer", formDataSer);


      // const jsonObject = {
      //   ...formDataSer,
      //   // ...purpose,
      // };
      var mobNumWs = payload.get("contact[phone]");
      var mobNum = mobNumWs.replace(/\s+/g, '');
      var mobresult = mobNum.substring(3);
      const jsonObject = {
        fullName: payload.get("contact[name]"),
        emailAddress: payload.get("contact[email]"),
        mobileNumber:mobresult,
      };
      // const dataint = formDataSer.contact[email];
      const dataint = payload.get('contact[email]');
      console.log('dataint', dataint);
      // console.log('idn', idn);

      try 
	    {
        const response = await fetch
		    (
          "https://api.voltasworld.com/edge-service/consent-service/consentEntry/offers-Voltas.com",
          {
            method: 'POST',
            body: JSON.stringify({
              apiKey: apiKey,
              identifier: dataint,
              data: jsonObject,
              purpose: purpose,
              language: textLangContent,
              languageId: textLangId,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.ok) {
          const json = await response.json();
          console.log("Details saved successfully");
          console.log("json", json);
          form.reset();
        } 
        else if (response?.status === 406) {
          // Specific handling for 406 with message from API
          // const errorMessage = result?.error?.message || "it's looks like some value is missing";
          alert('errorMessage');
        } else {
          // Generic error fallback
          // const errorMessage = result?.error?.message || "An error occurred while submitting the form";
          alert('errorMessage');
        }
      } 
	  catch (error) {
        console.error("Form submission error:", error);
        alert("An error occurred while submitting the form");
      }
    });
}; 